import * as React from 'react';
import {PropsWithChildren} from 'react';
import {BottomSheet} from "./BottomSheet";

export interface BottomSheetMenuItem {
    name: string;
    onClick: () => void;
}

interface Props {
    items: BottomSheetMenuItem[];
    handleClose: () => void;
}

export function BottomSheetMenu(props: PropsWithChildren<Props>) {
    const {items, handleClose} = props;

    return <BottomSheet handleClose={handleClose}>
        {items.map((item, index) => (
            <div key={index} onClick={(e) => {
                e.stopPropagation();
                item.onClick();
                handleClose();
            }} style={{padding: '12px 16px', cursor: 'pointer', borderBottom: '1px solid #eee'}}>
                {item.name}
            </div>
        ))}
    </BottomSheet>
}